export const POLICY_TYPES = {
    domain: 'Domain',
    domain_group: 'DomainGroup',
} as const;
